import { configureStore as createStore } from "@reduxjs/toolkit"
import rootReducer from "../reducers"

import { directAxiosInstance, ppmcAxiosInstance } from "@lib/api"

const configureStore = (initialState, cookies, requestObj, customHeaders) => {
    const api = directAxiosInstance(cookies, requestObj, customHeaders)
    const ppmcApi = ppmcAxiosInstance(cookies, requestObj)
    const store = createStore({
        reducer: rootReducer,
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                thunk: {
                    extraArgument: { api, ppmcApi },
                },
            }),
        preloadedState: initialState,
        devTools: false,
    })
    return store
}

export default configureStore
